import { render, staticRenderFns } from "./SqlDetailView.vue?vue&type=template&id=5ac1a1d0&"
import script from "./SqlDetailView.vue?vue&type=script&lang=js&"
export * from "./SqlDetailView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports